export const ADD_SOFTWARE_EDITION = 'ADD_SOFTWARE_EDITION';

export function addSoftwareEdition (edition) {
    return {
        type: ADD_SOFTWARE_EDITION,
        edition,
    };
}
